module.exports = __webpack_public_path__ + "media/bg/bg-1-02779d3b.jpg";